<div [class]="classes()">
  <div class="cart-group__header">
    <div class="cart-group__label">
      <ftr-icon class="cart-group__icon" icon="Courthouse" size="Small" />
      <span>{{ group().courthouse.name }}</span>
    </div>
    <div class="cart-group__label">
      <ftr-icon class="cart-group__icon" icon="Courtroom" size="Small" />
      <span>{{ group().courtroom.name }}</span>
    </div>
    <div class="cart-group__label">
      <ftr-icon class="cart-group__icon" icon="CalendarDay" size="Small" />
      <ftr-date [date]="group().recordingDate" [format]="dateFormat.DateLong" />
    </div>
  </div>
  <div class="cart-group__items">
    @for (item of group().items; track item.id) {
      <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: item }" />
    }
  </div>
</div>
